/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CardStatusDto } from './CardStatusDto';
import {
    CardStatusDtoFromJSON,
    CardStatusDtoFromJSONTyped,
    CardStatusDtoToJSON,
    CardStatusDtoToJSONTyped,
} from './CardStatusDto';

/**
 * Statuts des cartes UI spécifiques au produit Emprunteur (EMP)
 * @export
 * @interface BorrowerCardStatuses
 */
export interface BorrowerCardStatuses {
    /**
     * 
     * @type {CardStatusDto}
     * @memberof BorrowerCardStatuses
     */
    subscriptionRequest: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof BorrowerCardStatuses
     */
    subscriptionCertificate: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof BorrowerCardStatuses
     */
    insured: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof BorrowerCardStatuses
     */
    risk: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof BorrowerCardStatuses
     */
    conditions: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof BorrowerCardStatuses
     */
    contract: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof BorrowerCardStatuses
     */
    realEstate?: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof BorrowerCardStatuses
     */
    medicalSurvey?: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof BorrowerCardStatuses
     */
    medicalSurveyResponse?: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof BorrowerCardStatuses
     */
    approvedAgreement?: CardStatusDto;
    /**
     * 
     * @type {CardStatusDto}
     * @memberof BorrowerCardStatuses
     */
    medicalForm?: CardStatusDto;
}

/**
 * Check if a given object implements the BorrowerCardStatuses interface.
 */
export function instanceOfBorrowerCardStatuses(value: object): value is BorrowerCardStatuses {
    if (!('subscriptionRequest' in value) || value['subscriptionRequest'] === undefined) return false;
    if (!('subscriptionCertificate' in value) || value['subscriptionCertificate'] === undefined) return false;
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('risk' in value) || value['risk'] === undefined) return false;
    if (!('conditions' in value) || value['conditions'] === undefined) return false;
    if (!('contract' in value) || value['contract'] === undefined) return false;
    return true;
}

export function BorrowerCardStatusesFromJSON(json: any): BorrowerCardStatuses {
    return BorrowerCardStatusesFromJSONTyped(json, false);
}

export function BorrowerCardStatusesFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerCardStatuses {
    if (json == null) {
        return json;
    }
    return {
        
        'subscriptionRequest': CardStatusDtoFromJSON(json['subscriptionRequest']),
        'subscriptionCertificate': CardStatusDtoFromJSON(json['subscriptionCertificate']),
        'insured': CardStatusDtoFromJSON(json['insured']),
        'risk': CardStatusDtoFromJSON(json['risk']),
        'conditions': CardStatusDtoFromJSON(json['conditions']),
        'contract': CardStatusDtoFromJSON(json['contract']),
        'realEstate': json['realEstate'] == null ? undefined : CardStatusDtoFromJSON(json['realEstate']),
        'medicalSurvey': json['medicalSurvey'] == null ? undefined : CardStatusDtoFromJSON(json['medicalSurvey']),
        'medicalSurveyResponse': json['medicalSurveyResponse'] == null ? undefined : CardStatusDtoFromJSON(json['medicalSurveyResponse']),
        'approvedAgreement': json['approvedAgreement'] == null ? undefined : CardStatusDtoFromJSON(json['approvedAgreement']),
        'medicalForm': json['medicalForm'] == null ? undefined : CardStatusDtoFromJSON(json['medicalForm']),
    };
}

export function BorrowerCardStatusesToJSON(json: any): BorrowerCardStatuses {
    return BorrowerCardStatusesToJSONTyped(json, false);
}

export function BorrowerCardStatusesToJSONTyped(value?: BorrowerCardStatuses | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subscriptionRequest': CardStatusDtoToJSON(value['subscriptionRequest']),
        'subscriptionCertificate': CardStatusDtoToJSON(value['subscriptionCertificate']),
        'insured': CardStatusDtoToJSON(value['insured']),
        'risk': CardStatusDtoToJSON(value['risk']),
        'conditions': CardStatusDtoToJSON(value['conditions']),
        'contract': CardStatusDtoToJSON(value['contract']),
        'realEstate': CardStatusDtoToJSON(value['realEstate']),
        'medicalSurvey': CardStatusDtoToJSON(value['medicalSurvey']),
        'medicalSurveyResponse': CardStatusDtoToJSON(value['medicalSurveyResponse']),
        'approvedAgreement': CardStatusDtoToJSON(value['approvedAgreement']),
        'medicalForm': CardStatusDtoToJSON(value['medicalForm']),
    };
}

